import { render, staticRenderFns } from "./AssemblyImportConfig.vue?vue&type=template&id=158cb803&scoped=true&"
import script from "./AssemblyImportConfig.vue?vue&type=script&lang=js&"
export * from "./AssemblyImportConfig.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyImportConfig.vue?vue&type=style&index=0&id=158cb803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158cb803",
  null
  
)

export default component.exports